import React from "react";
import ApplicationHeader from "../header";
import ApplicationFooter from '../footer';
import { Layout } from "antd";
import { Outlet } from "react-router-dom";
import AppLayoutWrapper from "./style";

const PrivateLayout = () => {
  return (
    <Layout className="site-layout">
      <ApplicationHeader />
      <AppLayoutWrapper className="container">
        <Outlet />
      </AppLayoutWrapper>
      <ApplicationFooter/>
    </Layout>
  );
};
export default PrivateLayout;
